<template>
    <div class="gateway">
        <Space></Space>
        <div class="gateway_main">
            <div class="topCont">
                <div class="left">
                    <el-button type="primary" @click="toRefresh" size="small">今天</el-button>
                    <span class="el-icon-arrow-left" @click="prevWeek"></span>
                    <span class="el-icon-arrow-right" @click="nextWeek"></span>
                </div>
                <p>{{ currentDate }}</p>
                <div class="right">
                    <el-select v-if="isSuperadmin" v-model="regionValue" placeholder="请选择"
                               @change="getRegionTableData" size="small" class="mr" style="margin-right: 24px">
                        <el-option v-for="(item, index) in regionTreeList" :key="index" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                    <div class="btnTypesList">
                        <div class="item" v-for="(item, index) in btnTypes" :key="index"
                             @click="changeTypes(item.fieldType)"
                             :class="[fieldType == (index+1) ?'buttonActive' :``]">
                            {{ item.text }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="mainCont" style="height: calc(100% - 72px)">
                <div class="tables">
                    <el-table v-loading="loading" :data="tabRows" border :row-style="rowStyle" :key="timestamp"
                              class="new-table" header-row-class-name="new-table--header">
                        <el-table-column header-align="center" align="center" prop="name" label="" min-width="9%">
                        </el-table-column>
                        <el-table-column header-align="center" align="center"
                                         v-for="(propitem,j) in tabHeader.columns"
                                         :key="propitem" :prop="propitem" :label="tabHeader.columnMap[propitem]"
                                         min-width="13%">
                            <template slot-scope="scope">
                                <ul class="everyPlace">
                                    <!--                                     :style="[item.style || setInitialStyle(index, scope.row.data[propitem])]"-->
                                    <!--                                    -->
                                    <li v-for="(item, index) in scope.row.data[propitem]" :key="index"
                                        :style="scope.row.data[propitem][index].style"
                                        @click="getRandomColorClick(index, scope.row.data[propitem], scope.row.data[propitem][index].style.randomIndex)"
                                        @mouseover="changeBackgroundColor(index, scope.row.data[propitem],scope.row.data[propitem][index].style.randomIndex)"
                                        @mouseout="resetBackgroundColor(index, scope.row.data[propitem],scope.row.data[propitem][index].style.randomIndex)">
                                        <el-popover trigger="click" placement="right-start" width="346" :offset="-8"
                                                    popper-class="lockdom">
                                            <div style="width: 100%">
                                                <div class="lockdom-title">
                                                    {{ item.openDay }}
                                                </div>
                                                <el-form label-width="70" class="lockdom_form" style="width: 100%">
                                                    <el-form-item label="项目名称：">{{ item.businessName }}
                                                    </el-form-item>
                                                    <el-form-item label="开标地址：">{{ item.fieldName }}</el-form-item>
                                                    <el-form-item label="开标时间：">{{ item.opentime }}</el-form-item>
                                                </el-form>
                                            </div>
                                            <div slot="reference" style="width: 100%;">
                                                <p>{{ item.businessName }}</p>
                                                <span><em>{{item.businessName === '禁止场地预约' ?'': item.opentime.slice(0, 5) }}</em><em>{{
                                                        item.fieldName
                                                    }}</em></span>
                                            </div>
                                        </el-popover>
                                    </li>
                                </ul>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <Space></Space>
    </div>

</template>
<script>
import {formatDate} from '@/utils/index'
import {mapState} from 'vuex'
import {backColors} from "../tableCol";
import Space from '@/components/space.vue'
import pageTitle from '@/components/pageTitle.vue'

export default {
    components: {
        Space,
        pageTitle
    },
    data() {
        return {
            loading: true,
            regionValue: '',
            regionOptions: [],
            currentDate: '',
            currentFirstDate: '',
            rowStyle: {height: "45%",},
            btnTypes: [{text: '开标室', fieldType: '1'}, {text: '评标室', fieldType: '2'}, {text: '其他', fieldType: '3,4,9'}],
            fieldType: '1',
            detailArr: [],
            detailTopTime: '',
            tabHeader: {
                columns: [],
                columnMap: {},
            },
            tabRows: [],
            timestamp: "1",
            dialogVisible: false,
            backColors: backColors,

        }
    },
    created() {
        let date = new Date;
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        this.currentDate = y + '年' + m + '月';
        if (this.$route.query.regionCode) {
            this.regionValue = this.$route.query.regionCode;
            this.getAllTableData();
        }
        this.$store.dispatch('region/getRegionTree', '');
    },
    mounted() {
        this.getAllTableData();
    },
    computed: {
        ...mapState({
            regionTreeList: (state) => state.region.regionTreeList,
            isSuperadmin: (state) => state.user.supperAdmin,
        })
    },
    methods: {
        //给单元格设定样式
        cellStyle({row, column, rowIndex, columnIndex}) {
            if (columnIndex < 1) {
                return 'border-right:1px solid #cccccc';
            }
            let date = new Date().toLocaleDateString();
            let columnDate = new Date(column.property);
            if (date == columnDate.toLocaleDateString()) {
                return 'background:rgba(255,127,0,.2);';
            } else {
                return 'border-right:1px solid #cccccc';
            }
        },
        changeTypes(fieldType) {
            this.fieldType = fieldType;
            this.getAllTableData();
        },
        getRegionTableData() {
            this.getAllTableData()
        },
        toRefresh() {
            this.tabHeader = {}
            this.getAllTableData();
        },
        lookDetail(row, column, cell, event) {
            this.detailArr = row.data[column.property];
            this.detailTopTime = row.data[column.property][0].openDay;
            this.dialogVisible = true;
        },
        prevWeek() {
            let filter = "";
            if (this.tabHeader.columns && this.tabHeader.columns.length > 0) {
                let datestr = this.tabHeader.columns[0];
                let starts = new Date(datestr);
                starts = this.addDate(starts, -7)
                filter = formatDate(starts, "YYYY-MM-dd")
            }
            this.getAllTableData(filter);
        },
        nextWeek() {
            let filter = "";
            if (this.tabHeader.columns && this.tabHeader.columns.length > 0) {
                let datestr = this.tabHeader.columns[this.tabHeader.columns.length - 1];
                let starts = new Date(datestr);
                starts = this.addDate(starts, 1)
                filter = formatDate(starts, "YYYY-MM-dd")
            }
            this.getAllTableData(filter);
        },
        addDate(date, n) {
            date.setDate(date.getDate() + n);
            return date;
        },
        getAllTableData(startdate) {
            if (this.isSuperadmin && !this.regionValue) {
                this.regionValue = this.regionTreeList[0] ? this.regionTreeList[0].id : '';
            }
            let filter = {startdate: startdate, regionCode: this.regionValue, fieldType: this.fieldType}
            this.loading = true;
            this.$http.post('/field/apply/reportview', JSON.stringify(filter)).then(({data}) => {
                this.tabHeader = data.data.header || {};
                // this.tabRows = data.data.rows || [];
                // this.tabRows = data.data.rows.map((item) => {
                //     const indexOffset = item.name === '上午' ? 0 : 1;
                //     Object.keys(item.data).forEach((key, index) => {
                //         item.data[key] = item.data[key].map((subItem, idx) => ({
                //             ...subItem,
                //             style: {
                //                 borderColor: this.backColors[(index + indexOffset + idx) % this.backColors.length].border,
                //                 backgroundColor: this.backColors[(index + indexOffset + idx) % this.backColors.length].bg,
                //                 randomIndex: (index + indexOffset + idx) % this.backColors.length
                //             }
                //         }));
                //     });
                //     return item;
                // });


                this.tabRows = data.data.rows.map((item) => {
                let isBusinessNameForbidden = false; // 用于标记是否找到了'禁止场地预约'
                
                // 遍历动态日期键
                for (const dateKey in item.data) {
                    // 遍历该日期下的数组
                    for (let i = 0; i < item.data[dateKey].length; i++) {
                        if (item.data[dateKey][i].businessName === '禁止场地预约') {
                            isBusinessNameForbidden = true;
                            break; // 找到后退出循环
                        }
                    }
                    if (isBusinessNameForbidden) break; // 如果已找到，也退出外部循环
                }

                // 根据标记设定颜色
                const colorToUse = isBusinessNameForbidden 
                    ? { border: 'rgb(245, 34, 45)', bg: 'rgb(255, 204, 199)' } // 固定颜色
                    : null; // 或者维持原逻辑使用this.backColors计算颜色

                // 应用颜色逻辑
                Object.keys(item.data).forEach((key, index) => {
                    item.data[key] = item.data[key].map((subItem, idx) => {
                        let style = {};
                        if ('businessName' in subItem && subItem.businessName === '禁止场地预约') {
                            // 使用固定颜色
                            style = {
                                borderColor: colorToUse.border,
                                 backgroundColor: colorToUse.bg,
                                 randomIndex: 0
                            };
                        } else {
                            const indexOffset = item.name === '上午' ? 0 : 1;
                            style = {
                                borderColor: this.backColors[(index + indexOffset + idx) % this.backColors.length].border,
                                backgroundColor: this.backColors[(index + indexOffset + idx) % this.backColors.length].bg,
                                randomIndex: (index + indexOffset + idx) % this.backColors.length
                            };
                        }
                        return {...subItem, style};
                    });
                });

                return item;
            });


                this.timestamp = new Date().getTime().toString(10);
                this.loading = false;
            })
        },
        // 场地列表总况 背景颜色随机
        getRandomColorClick(index, row, randomIndex) {
            let initialStyle = {
                borderColor: this.backColors[randomIndex].border,
                backgroundColor: this.backColors[randomIndex].bgAct,
                randomIndex: randomIndex,
            };
            this.$set(row[index], 'style', initialStyle);
        },
        //鼠标移入 修改背景
        changeBackgroundColor(index, row, randomIndex) {
                let initialStyle = {
                borderColor: this.backColors[randomIndex].border,
                backgroundColor: this.backColors[randomIndex].bgAct,
                randomIndex: randomIndex,
            };
            this.$set(row[index], 'style', initialStyle);
       
          
        },
        //鼠标移出效果
        resetBackgroundColor(index, row, randomIndex) {
                let initialStyle = {
                borderColor: this.backColors[randomIndex].border,
                backgroundColor: this.backColors[randomIndex].bg,
                randomIndex: randomIndex,
            };
            this.$set(row[index], 'style', initialStyle);
        },
        




    },
    watch: {
        $route(to, from) {
            if (to.path == '/platformWay') {
                if (this.$route.query.regionCode) {
                    this.regionValue = this.$route.query.regionCode;
                    this.getAllTableData();
                }
                this.getAllTableData();
            }
        }
    }
}
</script>
<style lang="scss">
.lockdom {
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    border-radius: 6px;
    //border: 0.5px solid rgba(220, 220, 220, 1);
    background: rgba(255, 255, 255, 1);

    .lockdom-title {
        color: rgba(0, 0, 0, 0.85);
        font-family: "Microsoft YaHei";
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 8px;
    }

    .lockdom_form {
        width: 100%;

        .el-form-item {
            margin-bottom: 8px;
            //display: flex;

            .el-form-item__label {
                padding: 0;
                font-size: 14px !important;
                font-style: normal;
                font-weight: 400 !important;
                line-height: 22px !important;
                color: rgba(0, 0, 0, 0.65) !important;
            }

            .el-form-item__content {
                width: 244px;
                line-height: 22px!important;
                text-align: left;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                margin-left: 70px;
            }
        }

    }
}
</style>
<style lang="scss" scoped>
.gateway {
    width: 100%;
    //position: absolute;
    //height: 100%;
    .gateway_main {
        background: #fff;
        padding: 16px;
        //height: 100%;
        .topCont {
            width: 100%;
            margin: 0 0 12px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #fff;

            .left {
                display: flex;

                .el-button--medium {
                    width: 100px;
                }

                span {
                    width: 32px;
                    height: 32px;
                    background: #ffffff;
                    border: 1px solid #cccccc;
                    border-radius: 2px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 12px;
                    cursor: pointer;
                }

                span:hover {
                    color: #ffffff;
                    background: #2568ec;
                    border: 0;
                }
            }

            p {
                font-size: 16px;
                font-weight: 600;
            }

            .right {
                display: flex;

                .el-button--medium {
                    width: 100px;
                }

                .el-select {
                    margin-left: 10px;
                }

                .btnTypesList {
                    display: flex;
                    height: 32px;
                    align-items: center;
                    border-radius: 2px;
                    opacity: 1;
                    background: #e7e7e7;

                    .item {
                        width: 74px;
                        text-align: center;
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 14px;
                        font-weight: 400;
                        cursor: pointer;

                        &.buttonActive {
                            line-height: 32px;
                            border-radius: 2px;
                            background: rgb(37, 104, 236);
                            color: #fff;
                        }
                    }
                }
            }


        }

        .mainCont {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;

            .tables {
                width: 100%;

                /deep/ .el-table__header-wrapper {
                    border-bottom: 1px solid rgb(231, 231, 231);;

                    th {
                        height: 48px;
                        line-height: 48px;
                        padding: 0;
                        //border-right: 1px solid #cccccc;
                    }
                }

                /deep/ .el-table tbody tr:hover > td {
                    background: transparent !important;
                }

                .everyPlace {
                    width: 100%;
                    height: 302px;
                    cursor: pointer;
                    //height: 50%;

                    li {
                        width: 100%;
                        //height: 70px;
                        border-radius: 8px;
                        opacity: 1;
                        //border-left: 2px solid var(--random-border-color);
                        //background: var(--random-background-color);
                        border-left: 2px solid;
                        display: flex;
                        padding: 7px 8px;
                        flex-direction: column;
                        margin-bottom: 8px;
                        justify-content: space-around;

                        :deep(.el-popover__reference-wrapper) {
                            width: 100%;
                        }

                        p {
                            width: 100%;
                            word-break: break-all;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                            overflow: hidden;
                            text-align: left;
                            line-height: 22px;
                            margin-bottom: 8px;
                            color: rgba(0, 0, 0, 0.85);
                        }

                        span {
                            display: flex;
                            color: rgba(0, 0, 0, 0.65);

                            em {
                                font-style: normal;
                                cursor: pointer;
                            }

                            em:nth-child(1) {
                                width: 40%;
                                text-align: left;
                            }

                            em:nth-child(2) {
                                width: 60%;
                                text-align: right;
                            }
                        }
                    }

                    li:nth-child(2n) {
                    }
                }

            }
        }

        .el-dialog__wrapper {
            .top {
                display: flex;
                justify-content: space-between;
                padding: 0 10px;
                margin-bottom: 5px;
                border: 1px solid #cccccc;

                p {
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;

                    i,
                    em {
                        width: 100%;
                        font-style: normal;
                        margin: 5px 0;
                        display: -webkit-box;
                        word-break: break-all;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }

                p:nth-child(1) {
                    width: 70%;
                }

                p:nth-child(2) {
                    width: 30%;

                    em {
                        width: 100%;
                        text-align: right;
                    }

                    em:nth-child(2) {
                        padding-right: 10px;
                    }
                }
            }

            .bot {
                display: flex;
                justify-content: space-between;

                p {
                    display: flex;
                    flex-direction: column;

                    em {
                        font-style: normal;
                    }
                }
            }
        }
    }
}
</style>